import { combineReducers } from 'redux'
import auth from './slices/authSlice'
import { createAction } from '@reduxjs/toolkit'

export const revertAll = createAction('REVERT_ALL')

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        auth,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}
  
export default rootReducer
